export function formatClubDues(annualDues) {
  if (annualDues == null || annualDues === '') return null;
  const amount = Number(annualDues);
  if (Number.isNaN(amount)) return null;
  return `$${amount.toLocaleString(undefined, { maximumFractionDigits: 0 })}/yr`;
}

export function formatClubDistance(distanceMiles) {
  if (distanceMiles == null || Number.isNaN(Number(distanceMiles))) return null;
  return `${Number(distanceMiles).toFixed(1)} mi`;
}

export function formatClubOpenings(openings, maxMembers, memberCount) {
  if (openings != null) {
    if (openings <= 0) return 'Full';
    return `${openings} opening${openings === 1 ? '' : 's'}`;
  }
  if (maxMembers != null && memberCount != null) {
    const remaining = Math.max(0, Number(maxMembers) - Number(memberCount));
    if (remaining <= 0) return 'Full';
    return `${remaining} opening${remaining === 1 ? '' : 's'}`;
  }
  return null;
}

export function formatClubAcreage(acreage) {
  if (acreage == null || Number.isNaN(Number(acreage))) return null;
  return `${Number(acreage).toLocaleString()} ac`;
}

export function formatClubStandCount(standCount) {
  if (standCount == null) return null;
  const count = Number(standCount);
  if (Number.isNaN(count)) return null;
  return `${count} stand${count === 1 ? '' : 's'}`;
}
